<template>
  <RootModalComponent
    :name="$MODAL_NAME.REDIRECT"
    icon="ri-coupon-3-line"
    :title="'d_ws_user_redirect_modal_title' | translate"
    width="960"
    :footer="modalFooter"
    :mobile-type="$MODAL_TYPE_MOBILE.FULL"
    :frame="true"
    @cancel="onCancel"
    @redirect="onRedirect"
    @beforeOpen="beforeOpen"
    @closed="onClose"
  >
    <div class="redirect-modal">
      <div class="redirect-modal__inner">
        <div class="redirect-modal__left">
          <RadioList
            :list="list"
            :selected="treeSelected"
            @change="onRadioChanged"
          />
        </div>
        <div class="redirect-modal__right">
          <Dropdown
            v-if="dropdownItems && dropdownItems.length"
            :items="dropdownItems"
            :selected="dropdownSelected"
            :title="'d_ws_redirect_dropdown' | translate"
            @onSelected="onDropdownSelected"
          />
        </div>
      </div>
    </div>
  </RootModalComponent>
</template>

<script>
  
import RootModalComponent from './RootModalComponent'
import Dropdown from '../controls/Dropdown'
import RadioList from '../controls/RadioList';
import {REDIRECT_MODE} from "../../config";
import Vue from "vue";
  
export default {
  components: {
    RootModalComponent,
    Dropdown,
    RadioList
  },
  data() {
    return {
      treeSelected: 0,
      dropdownSelected: 0,
      list: [],
      dropdownItems: [],
      modalFooter: {
        lineTop: true,
        items: [
          {
            type: 'secondary',
            action: 'cancel',
            title: 'd_ws_button_cancel'
          },
          {
            type: 'primary',
            action: 'redirect',
            title: 'd_ws_redirect_button'
          }
        ]
      }
    }
  },
  computed: {
    currentTicket () {
      let currentTicket;

      if (this.$store.redirectMode === REDIRECT_MODE.REDIRECT) {
        currentTicket = this.$store.currentTicket
      } else if (this.$store.redirectMode === REDIRECT_MODE.BACK_TO_ALIVE) {
        currentTicket = this.$store.unsortedTickets.find(ticket => ticket.id === this.$store.ticketForContextMenu.id)
      }

      return currentTicket
    },
    REDIRECT_MODE() {
      return REDIRECT_MODE
    }
  },
  methods: {
    onDropdownSelected(item) {
      this.dropdownSelected = item.id;
    },
    onCancel() {
      this.$modal.hide(this.$MODAL_NAME.REDIRECT)
    },
    onRedirect() {
      const tags = this.$store.currentTicketTags.map(tag => tag.id);
      const lastTicketServicing = this.currentTicket.ticket_servicing_list ? this.currentTicket.ticket_servicing_list[this.currentTicket.ticket_servicing_list.length - 1] : this.$store.currentTicketServicing;

      if (this.$store.redirectMode === this.REDIRECT_MODE.REDIRECT) {
        this.$ticketService.redirect(
          lastTicketServicing.id,
          this.treeSelected,
          this.dropdownSelected,
          this.currentTicket.office_service_id,
          tags.length ? tags : [0]
        ).then(() => {
          this.$modal.hide(this.$MODAL_NAME.REDIRECT)
          this.$eventEmitter.emit(this.$eventEmitter.eventTypes.WORKSPACE_RELOAD)
        })
      } else if (this.$store.redirectMode === this.REDIRECT_MODE.BACK_TO_ALIVE) {
        this.$ticketService.backToAliveTicket(
          this.currentTicket.id,
          this.dropdownSelected,
          this.treeSelected
        ).then(() => {
          this.$modal.hide(this.$MODAL_NAME.REDIRECT)
          this.$modal.hide(this.$MODAL_NAME.CALL_TICKET_MOBILE)
        })
      }
    },
    onRadioChanged(id) {
      this.treeSelected = id;
      this.getWindows(this.treeSelected);
    },
    makeServicesTree(tree, groupNames) {
      const arr = [];
      tree.forEach(branch => {
        if (branch.hasOwnProperty('group')) {
          if (!branch.service && branch.child && branch.child.length) {
            const currentGroupNames = groupNames.find(gn => gn.id === branch.group.group_names_id);
            arr.push({
              id: branch.id,
              title: currentGroupNames.name[this.$store.activeLanguage] ? currentGroupNames.name[this.$store.activeLanguage] : Object.values(currentGroupNames.name).find(val => val),
              children: this.makeServicesTree(branch.child, groupNames)
            })
          }
        } else {
          arr.push({
            id: branch.id,
            title: this.$ticketService.getServiceTitle(branch.service),
            value: branch.id
          })
        }
      });

      return arr;
    },
    beforeOpen() {
      const groupNamesResponse = this.$store.deviceStartData.group_names;
      this.list = this.makeServicesTree(this.$store.deviceStartData.services_tree, groupNamesResponse);
      this.getWindows(this.currentTicket.office_service_id);
      this.treeSelected = this.currentTicket.office_service_id;
    },
    onClose() {
      this.dropdownSelected = 0;
      this.$store.ticketForContextMenu = null;
    },
    getWindows(service_id) {
      Promise.all([
        this.$crudService.get('ticket_servicing/redirect/windows', {service_id}),
      ]).then((resp) => {
        const windowsResponse = resp[0].data;

        this.dropdownItems = [{
          id: 0,
          title: this.$options.filters.translate('to_the_general_queue'),
          value: 0
        }].concat(
          windowsResponse.map((win) => {
            return {
              id: win.id,
              title: this.$options.filters.translate(`window_type_${win.type}`) + ` ${win.number}`,
              value: win.id
            }
          }));
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .redirect-modal {
    &__inner {
      display: flex;
      max-height: 480px;
    }
    &__left {
      width: 50%;
      background: var(--light-03);
      padding: 32px 40px;
      overflow: auto;
    }
    &__right {
      width: 50%;
      padding: 32px;
    }
  }

  @media (max-width: 425px) {
    .redirect-modal {
      height: calc(100vh - 105px);
      &__inner {
        display: block;
        height: 100%;
        max-height: 100%;
      }
      &__left,
      &__right {
        width: 100%;
      }
      &__left {
        height: calc(100% - 96px);
        overflow: auto;
        background: var(--light-02);
        padding: 16px 4px 16px 16px;
      }
      &__right {
        padding: 16px 8px;
        border-top: 1px solid var(--grey-04);
      }
    }
  }
</style>
